import { AnalyticIdentifier } from '@common/neo.tax';
import { Stack, Logo, Typography } from '@ui-components/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

import { StyledAuthHero, StyledAuthSubtitle, StyledAuthSwitch } from '../auth-form-header';
import { LoginRootContainer } from '../organisms.styled';

interface EnterpriseSsoFormHeaderProps {
  form: React.ReactNode;
  pageChangeLinkText: string;
  pageChangeText: string;
  pageChangeTo: string;
  subtitleIsActive?: boolean;
  title: string;
}

export const EnterpriseSsoFormHeader = ({
  form,
  pageChangeLinkText,
  pageChangeText,
  pageChangeTo,
  subtitleIsActive = true,
  title,
}: EnterpriseSsoFormHeaderProps): React.ReactElement | null => {
  const backToLoginAnchorId = useAnalyticId(AnalyticIdentifier.RTC_BACK_TO_LOGIN_LINK);

  return (
    <LoginRootContainer>
      <Logo animated={false} />
      <StyledAuthHero direction="column">
        <Typography as="h2" fontSize="3xl" fontWeight="extrabold">
          {title}
        </Typography>
        {subtitleIsActive && (
          <StyledAuthSubtitle as="p" fontSize="sm">
            Or{' '}
            <Typography as="span" fontSize="sm" fontWeight="medium">
              {pageChangeText}{' '}
              <StyledAuthSwitch id={backToLoginAnchorId} to={pageChangeTo}>
                {pageChangeLinkText}
              </StyledAuthSwitch>
            </Typography>
          </StyledAuthSubtitle>
        )}
      </StyledAuthHero>
      <Stack direction="column">{form}</Stack>
    </LoginRootContainer>
  );
};
